import { render, staticRenderFns } from "./npcTaskDialog.vue?vue&type=template&id=8180c2e8&scoped=true&"
import script from "./npcTaskDialog.vue?vue&type=script&lang=js&"
export * from "./npcTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./npcTaskDialog.vue?vue&type=style&index=0&id=8180c2e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8180c2e8",
  null
  
)

export default component.exports